

export default [
    {
        index: 1,
        title: '羽迹美形未来的发展趋势',
        time: '2021-04-08 16:40:30',
        startText: '在整容时代还没到来之前，从丑女摇身一变成为大美女似乎只会出现在童话世界里，而随着整容技术的启用和发展，丑和美似乎只隔着一次整容手术，而羽迹美形‍作为辅助整容一款必不可少的模拟软件帮助很多人实现了由不完美到完美的蜕变，随着羽迹美形‍的发展，其在未来还将会继续完善以下功能。',
        endText: '以上就是小编为大家总结的关于羽迹美形‍在未来的一些发展要点，另外此软件在未来还会将静态三维人脸和动态三维人脸进行有效结合，人脸仿真效果也会越来越好，进而其提供的模拟整容结果给予患者和医生的参考价值也会越来越大，成为辅助大家整容的得力助手。',
        itemList: [
            {

                title: '一、整容工具愈加丰富',
                content: '当下羽迹美形‍软件上面的整容工具可能还不是很多，只具备一些常用型的整容手术模拟工具，其在未来的发展和使用中将会添加更多好用的模拟整容工具，比如脂肪移植、双眼皮、埋线等整容工具将会更加好用，功能也会也会越来越贴近大家的需求。'
            },
            {
                title: '二、有更多的真实数据做支撑',
                content: '在以后的发展中此款软件将会更多的融入一些整容过程中的真实数据，整容师会根据这些数据分析结果，进而设计模拟整容结果，在未来的工作中，医生会根据一些模拟整容的数据，结合实际情况，自动为患者提供好的、适合患者的整容建议。'
            },
            {
                title: '三、改善算法',
                content: '此款整容模拟软件虽然已经投入使用，但是由于使用周期还不是很长，可能在模拟整容结果与实际整容结果的对比上在存在着诸多的欠缺，由此此软件在未来的使用中会根据系统实际手术情况，将模拟结果与实际整容结果进行比较并改善本系统的算法，从而达到更好的整容效果。'
            }
        ]
    },
    {
        index: 2,
        title: '羽迹美形的优点有哪些',
        time: '2021-04-08 16:40:30',
        startText: '现在整容已经成为了一件见怪不怪的事情，随着大家观念的改变，整容已经不再令人抵触的一件事情，另外整容医院技术水平的提升，也让人们打消了对整容风险的顾虑，现在很多医院都采用羽迹美形‍模拟整容软件，整容者可以提前看到自己整容后的样子，更让整容技术提升了一个层级，今天我们就来说一声羽迹美形‍的优点。',
        endText: '以上就是小编为大家总结的关于羽迹美形‍的一些优点，这个系统可以帮助整容设计师快速制定出针对整容者的整容方案，不管是对整容者来说，还是对整容医生来说，这款软件都起到了很好的使用效能，随着软件的不断优化，该软件的模拟准确率将会越来越高，使用此款整容模拟软件的整形医院也将越来越多，大家就此期待吧！',
        itemList: [
            {

                title: '一、交互页面友好',
                content: '该系统具有友好的交互界面和实时的三维人脸渲染，用户不仅可以对导入的三维人脸进行平移、旋转、放缩等操作查看人脸，还可以使用一些分析、整容工具与三维人脸进行实时交互，简单快捷。'
            },
            {
                title: '二、分析工具性能高',
                content: '该系统具有针对三维人脸的分析工具，通过使用人脸的比例测量工具、对称性测量工具、距离与角度测量工具可以协助整容设计师快速地分析三维人脸的对称性及协调性，绘制人脸等高线工具可以描述人脸老化程度，绘制彩色深度图工具可以帮助整容医生分析出人脸局部饱满情况。'
            },
            {
                title: '三、模拟整容工具多',
                content: '该系统具有针对三维人脸的模拟整容工具，包括模拟注射玻尿酸工具、模拟注射肉毒素工具、模拟隆鼻工具、模拟激光治疗工具等，这些工具能够帮助整容医生模拟整容手术的效果，并根据模拟结果优化手术过程。'
            }
        ]
    },
    {
        index: 3,
        time: '2021-04-08 16:40:30',
        title: '羽迹美形可以模拟哪些整容效果',
        startText: '现如今，大众对自身美的追求越来越高，越来越多的热加入整容大军的行业，用户在整容前，整容医生会根据待整容人脸的实际情况，并根据羽迹美形‍呈现出来的模拟整容效果，设计一套解决方案，并通过以往案例向用户呈现整容实际的效果，今天我们就来说一说羽迹美形‍可以模拟哪些整容效果。',
        endText: '除了有以上模拟功能外，羽迹美形‍还可以模拟激光祛斑、模拟皮秒镭射，通过模拟完成后会分析出整容效果，整容医生会根据模拟出来的数据和外貌效果给予患者一个整体完善的整容方案，让患者可以更清晰更明了的看到其整容后的效果，也可以在整容后进行前后对比。',
        itemList: [
            {

                title: '一、模拟注射玻尿酸',
                content: '这款软件可以模拟注射玻尿酸，主要用来模拟在人脸给定位置注射一定量玻尿酸后的效果使用者，首先需要选取注射范围和注射量，然后选取一个注射点进行注射，屏幕上会有一个针管注射的操作，在模拟注射玻尿酸操作后选中区域会更加饱满。'
            },
            {
                title: '二、模拟注射肉毒素',
                content: '模拟注射肉毒素主要用来模拟在人脸指定位置注射一定量肉毒素物的效果，使用者首先需要选取注射范围和收缩量，而后选取一个注射点来进行注射，屏幕上会有一个针管注射的操作，在模拟注射肉毒素操作，破损的区域会收缩。'
            },
            {
                title: '三、模拟隆鼻',
                content: '模拟隆鼻主要用来模拟给人脸鼻子处安装，一个鼻夹体后的效果使用者，只需要点击安装鼻夹体按钮，而后系统会在鼻子处显示一块鼻假体，人脸也会在此作用下逐渐形变成安装假体后的位置，在模拟隆鼻操作后，三维人脸的外壁会被垫高，改善了鼻部容貌。'
            }
        ]
    },
]



// WEBPACK FOOTER //
// ./src/utils/newJson.js